module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b1",
    attrs: {
      "id": "dec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/contents#dec"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "center1-o"
  }, [_c('span', [_vm._v("To Siny Widmer and Arie Baak"), _c('br'), _vm._v("\n  dear friends and colleagues who have shared my journey")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 66
// module chunks = 0